/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Receipt_TotalInputs */

const vi_receipt_total = /** @type {(inputs: Receipt_TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng thanh toán`)
};

/**

* @param {Receipt_TotalInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const receipt_total = /** @type {((inputs?: Receipt_TotalInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_TotalInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_receipt_total(inputs)
});